/**
 * Adapted from https://github.com/kevva/url-regex.
 */
function urlRegex() {
    var protocol = '(?:[a-z]+://)';
    var auth = '(?:\\S+(?::\\S*)?@)?';
    var host = '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)';
    var domain = '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*';
    var tld = '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?';
    var port = '(?::\\d{2,5})?';
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + host + domain + tld + ")" + port + path;
    return new RegExp(regex, 'ig');
}

function escapeStringRegExp(str) {
    return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
}
function createToken(type, text, raw) {
    if (raw === void 0) { raw = text; }
    return { type: type, text: text, raw: raw };
}
/**
 * Sort users by username length. Longest usernames first.
 */
function sortMentions(mentions) {
    return mentions.slice().sort(function (a, b) { return b.length - a.length; });
}
/**
 * Create a regex that matches a specific username or group being mentioned.
 *
 * @param {string} mention Mentionable name.
 * @return {RegExp}
 */
function mentionRegExp(mention) {
    return new RegExp("^" + escapeStringRegExp(mention) + "(?:\\b|\\s|\\W|$)", 'i');
}
/**
 * Case-insensitively get the correct emoji name from the possible emoji for an
 * input string.
 *
 * @param {Array.<string>} names All possible emoji names.
 * @param {string} match The input string.
 * @return {string|null} The correct emoji name (including casing), or `null` if
 *    the requested emoji does not exist.
 */
function findEmoji(names, match) {
    var compare = match.toLowerCase();
    for (var i = 0; i < names.length; i += 1) {
        var name_1 = names[i].toLowerCase();
        if (name_1 === compare) {
            return names[i];
        }
    }
    return null;
}
function tokenize(text, options) {
    var chunk;
    var i = 0;
    var mentions = sortMentions(options.mentions || []);
    var tokens = [];
    // adds a token of type `type` if the current chunk starts with
    // a `delim`-delimited string
    var delimited = function (type, start, endRx) {
        if (chunk[0] === start && chunk[1] !== start) {
            var end = 1 + chunk.slice(1).search(endRx);
            if (end) {
                tokens.push(createToken(type, chunk.slice(1, end)));
                i += end + 1;
                return true;
            }
        }
        return false;
    };
    var emoji = function (type, emojiNames) {
        var match = /^:([A-Za-z0-9_+-]+):/.exec(chunk);
        if (match) {
            // if a whitelist of emoji names is given, only accept emoji from that
            // list.
            var emojiName = emojiNames ? findEmoji(emojiNames, match[1]) : match[1];
            if (emojiName) {
                tokens.push(createToken(type, emojiName, match[0]));
                i += match[0].length;
                return true;
            }
        }
        return false;
    };
    var mention = function (type, start) {
        if (chunk[0] === start) {
            var maybeMention = chunk.slice(1);
            for (var mi = 0, ml = mentions.length; mi < ml; mi += 1) {
                var candidate = mentions[mi];
                if (mentionRegExp(candidate).test(maybeMention)) {
                    var end = candidate.length + 1;
                    tokens.push(createToken(type, chunk.slice(1, end), chunk.slice(0, end)));
                    i += end;
                    return true;
                }
            }
        }
        return false;
    };
    var linkRx = new RegExp("^" + urlRegex().source, 'i');
    var link = function (type) {
        var match = linkRx.exec(chunk);
        if (match) {
            tokens.push(createToken(type, chunk.slice(0, match[0].length)));
            i += match[0].length;
            return true;
        }
        return false;
    };
    // eat spaces
    var space = function () {
        // .slice again because `i` changed
        var m = /^\s+/.exec(text.slice(i));
        if (m) {
            tokens.push(createToken(7 /* Text */, m[0]));
            i += m[0].length;
        }
    };
    // tokenize text, just loop until it's done!
    chunk = text;
    while (chunk) {
        var found = emoji(4 /* Emoji */, options.emojiNames)
            || delimited(0 /* Italic */, '_', /_(\W|$)/)
            || delimited(1 /* Bold */, '*', /\*(\W|$)/)
            || delimited(2 /* Code */, '`', /`(\W|$)/)
            || delimited(3 /* Strike */, '~', /~(\W|$)/)
            || mention(5 /* Mention */, '@')
            || link(6 /* Link */);
        if (!found) {
            var end = chunk.indexOf(' ', 1) + /* eat space */ 1;
            if (end === 0) { // no match, = -1 + 1
                end = chunk.length;
            }
            // append to previous token if it was also text
            if (tokens.length > 0 && tokens[tokens.length - 1].type === 7 /* Text */) {
                tokens[tokens.length - 1].text += chunk.slice(0, end);
            }
            else {
                tokens.push(createToken(7 /* Text */, chunk.slice(0, end)));
            }
            i += end;
        }
        space();
        chunk = text.slice(i);
    }
    return tokens;
}
function httpify(text) {
    if (!/^[a-z]+:/.test(text)) {
        return "http://" + text;
    }
    return text;
}
/**
 * Parses a chat message into a tree-ish structure.
 */
function parse(message, options) {
    if (options === void 0) { options = {}; }
    if (typeof message !== 'string') {
        throw new TypeError('Expected a string');
    }
    return tokenize(message, options).map(function (token) {
        switch (token.type) {
            case 0 /* Italic */:
                return { type: 'italic', content: parse(token.text, options) };
            case 1 /* Bold */:
                return { type: 'bold', content: parse(token.text, options) };
            case 2 /* Code */:
                return { type: 'code', content: [token.text] };
            case 3 /* Strike */:
                return { type: 'strike', content: parse(token.text, options) };
            case 4 /* Emoji */:
                return { type: 'emoji', name: token.text };
            case 5 /* Mention */:
                return { type: 'mention', mention: token.text.toLowerCase(), raw: token.text };
            case 6 /* Link */:
                return { type: 'link', text: token.text, href: httpify(token.text) };
            case 7 /* Text */:
                return token.text;
        }
    });
}

export default parse;
